export const defaultAxisRangePadding = 0;
export default function getAxisRangePaddingConfig() {
  let originalRangePadding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultAxisRangePadding;
  return typeof originalRangePadding === 'number' ? {
    start: originalRangePadding,
    end: originalRangePadding
  } : {
    start: defaultAxisRangePadding,
    end: defaultAxisRangePadding,
    ...originalRangePadding
  };
}